// Kundvänd publik bas-URL — alla aktiverings- och återställningslänkar
// som skickas till kunder ska gå till den officiella domänen, inte till
// Lovable-preview/published URL.
export const CUSTOMER_BASE_URL = "https://access.lagamobilen.se";

export const customerUrl = (path: string) =>
  `${CUSTOMER_BASE_URL}${path.startsWith("/") ? path : `/${path}`}`;
